module.exports = __webpack_public_path__ + "img/lg_ring_g_c_0_0.5400e964.png";